<div class="card">
    <div class="header">
        <div class="vehicle-info">
            <div class="plate-row">
                <h3 class="plate">{{ displayId }}</h3>
                <span class="issued-date" *ngIf="displayIssuedAt">{{ displayIssuedAt }}</span>
            </div>
            <p class="model">
                {{ order.vehicle }}
                <ng-container *ngIf="order.year"> • {{ order.year }}</ng-container>
            </p>
        </div>
        <div class="status-badge" [ngClass]="getStatusClass(order.status)">
            {{ order.status }}
        </div>
    </div>

    <div class="divider"></div>

    <div class="details">
        <div class="client">
            <label>CLIENTE</label>
            <span>{{ order.client }}</span>
        </div>
        <div class="technician icon-text-row pill-bg">
            <span class="material-symbols-rounded icon">engineering</span>
            <span>{{ order.technician }}</span>
        </div>
    </div>

    <ng-container *ngIf="order.itens.length">
        <div class="divider"></div>

        <div class="item-list">
            <div class="item-row" *ngFor="let item of order.itens">
                <div class="item-row__header">
                    <span class="item-codigo">{{ item.codigo }}</span>
                    <span class="item-status-badge" *ngIf="hasItemStatus(item)" [ngClass]="itemStatusClass(item)">{{ itemStatusLabel(item) }}</span>
                </div>
                <p class="item-descricao">{{ item.descricao }}</p>

                <div class="item-values">
                    <div class="item-value">
                        <label>QTD</label>
                        <span>{{ item.quantidade }}</span>
                    </div>
                    <div class="item-value">
                        <label>VALOR ORIGINAL</label>
                        <span>{{ formatCurrency(item.valorOriginal) }}</span>
                    </div>
                    <div class="item-value">
                        <label>DESCONTO</label>
                        <span class="item-value--discount">{{ formatCurrency(item.desconto) }}</span>
                    </div>
                    <div class="item-value">
                        <label>TOTAL</label>
                        <span>{{ formatCurrency(item.total) }}</span>
                    </div>
                </div>

                <div class="item-actions" *ngIf="canEditApproval(item)">
                    <button type="button" class="btn-approve" [disabled]="item.isProcessing || item.flagAprovado === true"
                        (click)="approvalOS(item, true); $event.stopPropagation()">
                        <span class="material-symbols-rounded">check</span>
                        Aprovar
                    </button>
                    <button type="button" class="btn-reject" [disabled]="item.isProcessing || item.flagAprovado === false"
                        (click)="approvalOS(item, false); $event.stopPropagation()">
                        <span class="material-symbols-rounded">close</span>
                        Reprovar
                    </button>
                </div>
                <p class="item-error" *ngIf="item.actionError">{{ item.actionError }}</p>
            </div>
        </div>
    </ng-container>
</div>
